import * as S from './style';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as R from '../../constants/routes';
import {
  faHome,
  faInfo,
  faImage,
  faQuoteLeft,
  faPhone,
  faFileAlt,
  faListUl
} from '@fortawesome/free-solid-svg-icons';
const infRout = [
  {
    name: 'Home',
    path: R.HERO,
    icon: faHome
  },
  {
    name: 'About',
    path: R.ABOUT,
    icon: faInfo
  },
  {
    name: 'Resume',
    path: R.RESUME,
    icon: faFileAlt
  },
  {
    name: 'Services',
    path: R.SERVICES,
    icon: faListUl
  },
  {
    name: 'Portfolio',
    path: R.PORTFOLIO,
    icon: faImage
  },
  {
    name: 'Testimonials',
    path: R.TESTIMONIALS,
    icon: faQuoteLeft
  },
  {
    name: 'Contact',
    path: R.CONTACT,
    icon: faPhone
  }
];

const Header = () => {
  return (
    <S.Header>
      <S.HeaderContainer>
        <S.HeaderLogo>
          <S.HeaderLogoLink to={R.HERO}>
            <S.HeaderLogoImg src={'/images/logo_elham.png'} />
          </S.HeaderLogoLink>
        </S.HeaderLogo>
        <S.HeaderNav>
          {infRout.map(({ name, path, icon }) => (
            <S.HeaderNavLink to={path} key={name} exact>
              <FontAwesomeIcon icon={icon} />
              <S.Label>{name}</S.Label>
            </S.HeaderNavLink>
          ))}
        </S.HeaderNav>
      </S.HeaderContainer>
    </S.Header>
  );
};

export default Header;
